<template>
    <!--弹窗-->
    <el-dialog
        width="600px"
        :title="title"
        :visible.sync="visible"
        :before-close="handleClose"
    >
        <el-form
            ref="formData"
            :model="formData"
            label-width="180px"
            size="mini"
        >
            <div class="download">
                <el-upload
                    class="upload-demo"
                    drag
                    action="/"
                    accept=".xls, .xlsx"
                    ref="upload"
                    :file-list="files"
                    :http-request="handleUpload"
                    :on-exceed="handExceed"
                    :on-remove="handleRemove"
                    :auto-upload="false"
                    :limit="1"
                    multiple
                >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">
                        将文件拖到此处，或<em>点击上传</em>
                    </div>
                    <div
                        class="el-upload__text"
                        style="font-size: 12px;margin-top: 5px;"
                    >
                        只能上传.xls/.xlsx文件
                    </div>
                </el-upload>
            </div>
        </el-form>
        <el-form
            ref="form"
            :inline="true"
            :rules="rules"
            :model="listData"
            class="query-form"
            size="mini"
            label-width="80px"
            style="padding: 10px 0 0 100px"
        >
            <!-- <el-form-item label="ASIN: " class="query-form-item" prop="asin">
                <el-input v-model="listData.asin" placeholder="请输入ASIN" clearable style="width: 260px;"></el-input>
            </el-form-item> -->
            <el-form-item
                label="词根: "
                class="query-form-item"
                prop="manual_root"
            >
				<el-input
				    type="textarea"
				    style="width: 420px;margin-top:12px;"
				    :rows="8"
				    placeholder="请输入词根数据，已换行区分"
				    v-model="listData.manual_root"
				>
				</el-input>
            </el-form-item>
        </el-form>
        <el-row style="margin-top:17px; ">
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                type="danger"
                plain
                @click="handleClose()"
                >取 消</el-button
            >
            <el-button
                style="float:right"
                size="mini"
                type="primary"
                @click="submitForm('formData')"
                >确定</el-button
            >
        </el-row>
    </el-dialog>
</template>
<script>
import * as api from "@/api/advAnalys/advAnalys";
export default {
    data() {
        return {
            files: [],
            dateArr: [],
            rules: {
                manual_root: [
                    {
                        required: true,
                        message: "请输入词根",
                        trigger: "blur"
                    }
                ],
            },
            listData: {}
        };
    },
    props: {
        formData: {
            type: Object,
            default: () => {}
        },
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ""
        },
        us_arr: {
            type: Array,
            default: () => []
        },
        state: String,
        asin: Number
    },
	mounted() {
	    if (this.formData.id) {
	        // const listData = JSON.parse(JSON.stringify(this.formData));
	        // listData.dateArr = [
	        //     this.formData.start_date,
	        //     this.formData.end_date
	        // ];
	        // this.listData = listData;
	        // let arr = JSON.parse(this.formData.manual_root);
	        // let manual_root = "";
	        // arr.forEach((element, index) => {
	        //     manual_root = manual_root + element + "\r\n";
	        // });
	        this.listData = {
	            manual_root: this.formData.manual_root.join('\r\n'),
	        };
	    }
	},
    methods: {
        handleUpload(raw) {
            this.files.push(raw.file);
        },
        handExceed(files, fileList) {
            this.$message({
                type: "warning",
                message: `当前限制选择 1 个文件，共选择了 ${files.length +
                    fileList.length} 个文件.`
            });
            return;
        },
        handFileSuccess() {
            this.files = [];
            this.$refs.upload.clearFiles();
        },
        handleRemove(file, fileList) {
            this.files = fileList;
        },
        // 保存信息
        submitForm() {
            this.$refs["form"].validate(valid => {
                if (valid) {
                    this.$refs.upload.submit(); // 这里是执行文件上传的函数，其实也就是获取我们要上传的文件
                    if (this.files.length == 0) {
                        this.$message.warning(`当前限制只能上传选择 1 个文件`);
                        return;
                    }
                    let file = new FormData();
					let manual_root = this.listData.manual_root.split(/[(\r\n)\r\n]+/).filter(function(s){return s && s.trim()})
					for(let i=0;i<manual_root.length;i++){
						manual_root[i] = manual_root[i].trim()
					}	
                    file.append("file", this.files[0]);
                    file.append("manual_root", JSON.stringify({manual_root:manual_root}));
					
                    const loading = this.$loading({
                        lock: true,
                        text: "上传中...",
                        spinner: "el-icon-loading",
                        background: "rgba(0, 0, 0, 0.7)"
                    });
                    api.add_ad_group_analysis(file)
                        .then(res => {
                            if (res.code === 0) {
                                this.$message({
                                    message: "上传成功",
                                    type: "success"
                                });
                                this.disabled = false;
                                this.handleClose(true);
                            } else {
                                this.disabled = false;
                                this.$message({
                                    message: res.message,
                                    type: "error"
                                });
                            }
                        })
                        .catch(() => {
                            this.disabled = false;
                        })
                        .finally(() => {
                            loading.close();
                        });
                } else {
                    this.loading = false;
                    this.$message({
                        type: "error",
                        message: "请填写相应内容！"
                    });
                }
            });
        },
        // 关闭弹窗
        handleClose(isshow = false) {
            this.handFileSuccess();
            this.listData = {};
            this.$refs["formData"].resetFields();
            this.$emit("close-callback", isshow);
        }
    }
};
</script>
<style type="text/scss" lang="scss" scoped>
.download {
    display: flex;
    justify-content: center;
}
.top {
    margin: 0px auto;
    width: 60%;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
}
</style>
